var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerFullTimeJobsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.522,
    height: 53.383,
    viewBox: "0 0 63.522 53.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22071",
    "data-name": "Group 22071",
    transform: "translate(-938.553 -116.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    width: 16.093,
    height: 3.634,
    transform: "translate(943.515 166.005)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M0,0H16.093V3.634H0Z",
    transform: "translate(938.553 166.005)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1987",
    "data-name": "Rectangle 1987",
    width: 11.983,
    height: 16.749,
    transform: "translate(965.938 152.889)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M0,0H11.983V16.749H0Z",
    transform: "translate(962.244 152.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11225",
    "data-name": "Path 11225",
    d: "M895.225,919.294l3.695,2.515v-2.515Z",
    transform: "translate(79.002 -766.405)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11226",
    "data-name": "Path 11226",
    d: "M903.171,303.552c-.185-.028-.743.488-.743.488-1.192.138-2.935.454-3.562.575a8.09,8.09,0,0,1-2.809-.79c-1.389-.557-2.74-1.2-2.74-1.2-.771-.039-1.647,1.367-.083,2.262a11.843,11.843,0,0,0,2.168.582h0a16.2,16.2,0,0,0,3.68.459,20.532,20.532,0,0,0,3.67-1.321h0l.012-.006a1.371,1.371,0,0,1,.525-.143,1.172,1.172,0,0,0,.692-.474c.014-.1-.627-.4-.813-.431",
    transform: "translate(81.748 -174.309)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11227",
    "data-name": "Path 11227",
    d: "M843.513,479.7l-.656.133s-3-3.375-3.467-4.795c-.248-.759-1.834-1.087-3.491-1.515-1.442-.373-2.939-.822-3.653-1.7-1.536-1.883.965-4.2.965-4.2s2.659,1.58,4.953,3.213c1.6,1.141,3.028,2.307,3.243,2.978.521,1.63,1.627,4.729,2.107,5.882",
    transform: "translate(139.95 -332.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11228",
    "data-name": "Path 11228",
    d: "M1097.733,766.283h.369c.124-.019.215-.055.342-.072a.342.342,0,0,1,.3.072l0,0h1.568c.04-.056,0-.187-.036-.283a.223.223,0,0,0-.147-.134,1.693,1.693,0,0,1-.794-.363c-.169-.153-.816-.561-.816-.561h0c-.014,0-.082.021-.376.269-.152.128-.411-.181-.411-.181a.369.369,0,0,0-.085.115.392.392,0,0,0-.034.241,1.56,1.56,0,0,1-.112.582c-.037.108-.067.184-.067.184s-.018.089.3.128",
    transform: "translate(-115.148 -618.207)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11229",
    "data-name": "Path 11229",
    d: "M838.163,470.842l-2.264,2.684c-1.442-.373-2.939-.822-3.653-1.7-1.536-1.883.965-4.2.965-4.2s2.659,1.58,4.953,3.213",
    transform: "translate(139.95 -332.739)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11230",
    "data-name": "Path 11230",
    d: "M765.368,488.511s-.182.576-.48,1.442c-.376,1.095-.935,2.654-1.542,4.1-.133.318-.269.63-.406.931a10.5,10.5,0,0,1-1.477,2.551c-.818.871-2.805,6.473-2.805,6.473l-.5-.137s-.69-4.783,1.756-7.5a.173.173,0,0,0,.049-.1h0c.033-.4.149-2.207.4-4.035.062-.449.133-.9.212-1.329,0-.028.01-.055.015-.082.372-1.992.728-2.879,1.188-3.324l3.382.963Z",
    transform: "translate(210.688 -351.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11231",
    "data-name": "Path 11231",
    d: "M751.711,886.957h.369c.124-.02.215-.055.342-.072a.342.342,0,0,1,.3.072l0,0h1.568c.039-.056,0-.187-.035-.283a.223.223,0,0,0-.147-.134,1.691,1.691,0,0,1-.794-.363c-.169-.153-.816-.561-.816-.561h0c-.014,0-.082.021-.376.269-.152.128-.411-.181-.411-.181a.368.368,0,0,0-.085.115.39.39,0,0,0-.034.241,1.561,1.561,0,0,1-.112.582c-.037.108-.067.184-.067.184s-.018.089.3.128",
    transform: "translate(217.085 -734.072)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11232",
    "data-name": "Path 11232",
    d: "M608.778,344.523s-.566,1.384-1.218,2.732a8.091,8.091,0,0,1-1.545,2.476c-.545.333-2.047,1.272-3.021,1.973,0,0-.76-.006-.878.14s-.391.8-.311.866a1.172,1.172,0,0,0,.831-.115,1.37,1.37,0,0,1,.484-.248l.013,0h0a20.533,20.533,0,0,0,3.6-1.494,16.193,16.193,0,0,0,2.413-2.817h0a11.846,11.846,0,0,0,1.211-1.89c.554-1.714-1.04-2.164-1.584-1.616",
    transform: "translate(360.743 -214.327)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11233",
    "data-name": "Path 11233",
    d: "M773.523,163.337a2.854,2.854,0,0,0-.2-.262.636.636,0,0,0,.25-.038c.2-.082.289-.713.259-.9s-.306-.728-.646-.782-.692.324-.692.324c.063-.273.638-.43.638-.43-1.186.219-1.125,1.009-1.117,1.082-1.085-.387-1.722,1.657-1.722,1.657l2.811,1.657s.007-.451.276-.422c.418.045.766-.982.145-1.887",
    transform: "translate(198.958 -38.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11234",
    "data-name": "Path 11234",
    d: "M806.5,267.06a1.938,1.938,0,0,1-1.5-.139c.055-.055.036-.221-.015-.437a3.187,3.187,0,0,0-.392-.9c-.046-.078-.092-.157-.147-.24l.074-.028,1.253-.5s.2.364.415.7c.18.277.369.525.451.516,0,0,.834.567-.143,1.037",
    transform: "translate(166.164 -138.004)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11235",
    "data-name": "Path 11235",
    d: "M809.325,267.933a1.844,1.844,0,0,1-.788,1.548,3.192,3.192,0,0,0-.392-.9Z",
    transform: "translate(162.611 -141.001)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11236",
    "data-name": "Path 11236",
    d: "M772.8,220.936s1.632-.643,1.216-1.653-.486-1.773-1.545-1.405-1.1.836-1.045,1.207.939,1.992,1.374,1.851",
    transform: "translate(197.879 -92.85)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11237",
    "data-name": "Path 11237",
    d: "M768.568,216.515a1.451,1.451,0,0,0,.973-.411,2.086,2.086,0,0,1-1.1-.879,1.747,1.747,0,0,0-1.474.192.423.423,0,0,0-.079.177c-.144-.047-.36-.035-.485.372-.187.611.479,1.277.479,1.277.162-.046-.021-.59-.046-.88a1.374,1.374,0,0,1,.159-.617,2.925,2.925,0,0,0,1.845,1.142,4.094,4.094,0,0,1-.979-.526,1.253,1.253,0,0,0,.709.153",
    transform: "translate(202.724 -90.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11238",
    "data-name": "Path 11238",
    d: "M763.158,294.277c-.014-.049-.029-.1-.044-.151a3.828,3.828,0,0,0,.412-1.234,2.477,2.477,0,0,0-.078-1.207,8.256,8.256,0,0,0-1.631-.676l-.006,0-.02,0a6.932,6.932,0,0,0-1.6.153.79.79,0,0,1-.384.935,1.165,1.165,0,0,1-1.229-.1l-.06.042h0a14.174,14.174,0,0,0-1.7,1.268c-.14.236-.742,1.4-.742,1.4s.191.98,2.3,1.062a4.879,4.879,0,0,1,.35,1.175c.168,1.33-.027,2.38.169,3.156s3.72.334,4.359.184.495-.831.544-1.493a24.767,24.767,0,0,0-.64-4.517",
    transform: "translate(212.607 -163.14)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11239",
    "data-name": "Path 11239",
    d: "M917.543,331.365a3.827,3.827,0,0,1-.415,1.239,4.174,4.174,0,0,0-.645-1.544,3.123,3.123,0,0,1,1.06.3",
    transform: "translate(58.591 -201.613)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240",
    "data-name": "Path 11240",
    d: "M582.76,530.52a11.117,11.117,0,0,1,.8-.89,2.424,2.424,0,0,1,.8-.226c.035.033.037.081-.04.149s-.37.239-.328.258.927-.421,1.054-.273-.072.76-.413,1.053a4.7,4.7,0,0,1-1.423.459c-.543.347-.445-.531-.445-.531",
    transform: "translate(379.022 -392.048)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241",
    "data-name": "Path 11241",
    d: "M292.794,460.644a2.045,2.045,0,0,0,2.145.651,3.638,3.638,0,0,0,.262-1.086c0-.057,0-.112,0-.164.006-.519.024-.81.024-.81h0c-.055-.023-1.836-.754-1.835-.694a3.16,3.16,0,0,1-.6,2.1",
    transform: "translate(657.427 -324.01)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11242",
    "data-name": "Path 11242",
    d: "M312.224,466.709a2.787,2.787,0,0,0,1.633,1.169c.006-.519.024-.81.024-.81h0a11.449,11.449,0,0,0-1.656-.359",
    transform: "translate(638.771 -331.843)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11243",
    "data-name": "Path 11243",
    d: "M301,395.11s-2,.471-2.278-.781-.717-2.035.55-2.389,1.622.07,1.815.465.427,2.55-.087,2.7",
    transform: "translate(652.027 -259.939)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11244",
    "data-name": "Path 11244",
    d: "M274.183,371.01c-.027.017-.459.15-1.275-1.477a1.417,1.417,0,0,1,.083-1.3,3.837,3.837,0,0,1,2.239-1.039c.88-.167,1.092.328,1.3.826a2.687,2.687,0,0,0,.846.953c-.759.424-1.673-.182-1.99-.083s-.429.6-.452.759-.06.293-.459.15-.18.564-.116.7c0,0,.054.36-.174.507",
    transform: "translate(676.634 -236.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11245",
    "data-name": "Path 11245",
    d: "M116.957,1175.257h-1.213c-.254,0-.537-.258-.608-.731s-.594-.731-.707-1.118.467-.931.467-.931l.1-.126.1-.131.961.229s.024.232.038.527c.01.213.016.46,0,.676-.028.516.143,1.071.595,1.172s.265.433.265.433",
    transform: "translate(828.698 -1009.253)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M307.384,1205.288h-3.216a.291.291,0,0,1-.068-.02c-.215-.111-.147-.957-.122-1.219,0-.048.008-.077.008-.077s1.131-.931,1.287-.218c0,.022.011.044.017.066h0c.2.667,1.074.97,1.581,1.055a.558.558,0,0,1,.514.413",
    transform: "translate(646.717 -1039.272)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11247",
    "data-name": "Path 11247",
    d: "M258.292,774.825s-.172,2.143-.374,4.719c-.274,3.5-.6,7.8-.637,8.612-.056,1.414-.283,3.676-.283,3.676a1.778,1.778,0,0,1-1.612.311,37,37,0,0,1-1.231-6.645l-.013-.169c-.254-3.478-.65-10.8-.65-10.8Z",
    transform: "translate(695.161 -627.408)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11248",
    "data-name": "Path 11248",
    d: "M258.292,774.825s-.172,2.143-.374,4.719l-3.763,5.954-.013-.169c-.254-3.478-.65-10.8-.65-10.8Z",
    transform: "translate(695.161 -627.408)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M135.562,754.643s-3.1,7.761-5.132,11.409-2.672,4.665-2.672,4.665-1.166-.467-1.272-.785c0,0,.778-7.041,2.142-8.758a12.9,12.9,0,0,0,1.718-4.9c.042-1.018.276-3.032.276-3.032Z",
    transform: "translate(817.107 -606.971)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11250",
    "data-name": "Path 11250",
    d: "M139.808,746.7a10.5,10.5,0,0,1-.139,1.118,2.286,2.286,0,0,1-.5.6c-.045-.007-.072-.043-.049-.137s.158-.384.115-.377-.491.825-.669.779-.353-.627-.247-1.037.827-1.055.854-1.121c.233-.561.63.172.63.172",
    transform: "translate(805.772 -600.323)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11251",
    "data-name": "Path 11251",
    d: "M157.752,524.371c.343.11.4.085.4.085s1.668-3.037,1.837-3.315,3.541-3.405,3.541-3.405l-.867-3.232s-3.836,4.967-4.25,5.68a15.072,15.072,0,0,0-1.085,3.913,1,1,0,0,0,.426.274",
    transform: "translate(787.496 -377.747)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11252",
    "data-name": "Path 11252",
    d: "M230.617,501.595c-.012.664-.051,1.41-.1,2.168l-.01.135c-.033.469-.069.94-.111,1.4-.017.184-.034.366-.053.544l0,.024c0,.067-.01.139-.017.206-.169,1.719-.346,3.076-.379,3.1a.192.192,0,0,1-.132.034,19.628,19.628,0,0,1-2.9-.194,8.344,8.344,0,0,1-2.576-1.068c-.112-.066-.369-.243-.348-.374s.058-.354.107-.617a33.366,33.366,0,0,0,.554-4.327q.029-.514.083-1.014a15.39,15.39,0,0,1,.449-2.422,4.7,4.7,0,0,1,1.628-2.807c.091-.051.58.26,1.029.549a1.984,1.984,0,0,0,1.277.3l.374.414a4.177,4.177,0,0,1,1.067,2.223q.015.11.025.235a14.6,14.6,0,0,1,.035,1.495",
    transform: "translate(723.49 -360.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11253",
    "data-name": "Path 11253",
    d: "M316.045,573.045c-.012.664-.051,1.41-.1,2.167l-.009.135a6.932,6.932,0,0,1-2.971-4.56,7.043,7.043,0,0,1,3.048.763,14.625,14.625,0,0,1,.035,1.495",
    transform: "translate(638.062 -431.786)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11254",
    "data-name": "Path 11254",
    d: "M318.586,532.258c-.133-.359-.339-.336-.339-.336s-3.828.954-4.171.995a41.314,41.314,0,0,1-4.122-1.475s-1.487-.667-2.184-.058a1.664,1.664,0,0,0-.491,1.764A1.684,1.684,0,0,0,308.7,534.4a44.869,44.869,0,0,0,5.261.476,21.133,21.133,0,0,0,4.685-2.076,1.2,1.2,0,0,0-.063-.544",
    transform: "translate(643.587 -393.707)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11255",
    "data-name": "Path 11255",
    d: "M1493.44,729.933s.532.493.428.843-.584.584-.648,1.012-.324.661-.558.661h-1.113s-.172-.3.243-.392.572-.594.546-1.061a8.342,8.342,0,0,1,.039-1.089l.882-.208Z",
    transform: "translate(-493.525 -584.367)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11256",
    "data-name": "Path 11256",
    d: "M1300.757,758.968a2.05,2.05,0,0,1-.5.058h-2.517c.008-.075.067-.342.479-.408.465-.076,1.271-.346,1.45-.941.006-.019.011-.039.016-.058.143-.635,1.18.194,1.18.194s0,.026.007.069c.024.234.086.987-.111,1.086",
    transform: "translate(-307.47 -610.943)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11257",
    "data-name": "Path 11257",
    d: "M1312.841,364.1s.158,1.966.343,4.33c.252,3.211.555,7.154.585,7.9.052,1.3.26,3.372.26,3.372a1.631,1.631,0,0,0,1.479.285,33.956,33.956,0,0,0,1.129-6.1c0-.051.008-.1.012-.155.233-3.191.6-9.909.6-9.909Z",
    transform: "translate(-321.972 -233.077)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11258",
    "data-name": "Path 11258",
    d: "M1312.841,364.1s.158,1.966.343,4.33l3.452,5.462c0-.051.008-.1.012-.155.233-3.191.6-9.909.6-9.909Z",
    transform: "translate(-321.972 -233.077)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11259",
    "data-name": "Path 11259",
    d: "M1330.9,345.586s2.84,7.121,4.708,10.467,2.451,4.28,2.451,4.28,1.07-.428,1.167-.72c0,0-.714-6.46-1.965-8.035a11.834,11.834,0,0,1-1.576-4.494c-.039-.934-.253-2.782-.253-2.782Z",
    transform: "translate(-339.313 -214.326)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11260",
    "data-name": "Path 11260",
    d: "M1066.628,275.571a8.549,8.549,0,0,0-.9-.167,1.856,1.856,0,0,0-.589.235c-.006.037.016.067.094.072s.336-.028.32,0-.759.177-.768.327.4.427.743.446a3.6,3.6,0,0,0,1.078-.386c.492-.043.022-.53.022-.53",
    transform: "translate(-83.801 -148.174)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11261",
    "data-name": "Path 11261",
    d: "M1100.665,142.991c-.11-.352-.085-.408-.085-.408s3.123-1.689,3.409-1.86,3.513-3.606,3.513-3.606l3.306.91s-5.116,3.9-5.849,4.317a15.446,15.446,0,0,1-4.017,1.086,1.027,1.027,0,0,1-.278-.439",
    transform: "translate(-118.168 -15.398)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11262",
    "data-name": "Path 11262",
    d: "M1234.745,58.177s-1.159,2.039-2.292,2.305a3.094,3.094,0,0,1,.323-1.154c-.113-.133-.212-.256-.3-.365a6.831,6.831,0,0,1-.421-.589l.384-1.034.261-.7a3.383,3.383,0,0,0,.407.587,2.774,2.774,0,0,0,1.635.95",
    transform: "translate(-244.409 61.872)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    "data-name": "Path 11263",
    d: "M1233.11,71.372a2.151,2.151,0,0,1-.632,1.737,6.846,6.846,0,0,1-.421-.589l.384-1.034a2.2,2.2,0,0,1,.669-.114",
    transform: "translate(-244.408 47.728)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    "data-name": "Path 11264",
    d: "M1189.086,23.482s1.732-.675,1.295-1.747-.508-1.881-1.632-1.5-1.171.882-1.112,1.275.988,2.115,1.449,1.967",
    transform: "translate(-201.742 96.916)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M1247.467,98.824c-.7,1-5.921,2.346-5.859,1.651a7.552,7.552,0,0,0,0-1.371q-.02-.223-.056-.474a10.92,10.92,0,0,0-1.151-3.447q-.079-.153-.165-.308a10.64,10.64,0,0,1-.724-1.627,5.012,5.012,0,0,1-.325-2.7l0-.009c1.092-.5,1.515-2.463,1.515-2.463s3.725.669,5.811,5.633c0,0,1.559,4.241.952,5.115",
    transform: "translate(-251.178 31.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    "data-name": "Path 11266",
    d: "M1272.748,200.45q-.02-.223-.056-.474a10.923,10.923,0,0,0-1.151-3.447,4.879,4.879,0,0,1,.47-1.614c.743-1.113,1.176-1.287,1.176-1.287s1.114,4.7-.439,6.822",
    transform: "translate(-282.319 -69.657)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    "data-name": "Path 11267",
    d: "M1102.726,336.781a11.119,11.119,0,0,0-1.19.112,2.423,2.423,0,0,0-.656.506c.006.048.043.078.144.057s.412-.155.4-.11-.89.494-.847.685.654.394,1.092.295,1.145-.843,1.216-.87c.6-.23-.162-.674-.162-.674",
    transform: "translate(-118.168 -207.105)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    "data-name": "Path 11268",
    d: "M1146.965,121.894c-.207-.333-.058-.486-.058-.486s3.183-2.492,3.432-2.744a42.338,42.338,0,0,0,1.405-4.261s.4-1.622,1.329-1.8a1.705,1.705,0,0,1,1.735.714,1.726,1.726,0,0,1,.117,1.941,45.993,45.993,0,0,1-2.931,4.552c-1.065,1.034-4.63,2.478-4.63,2.478a1.235,1.235,0,0,1-.4-.394",
    transform: "translate(-162.601 8.172)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11269",
    "data-name": "Path 11269",
    d: "M1175.078.4c.012-.024.047-.05.133-.076a.361.361,0,0,0-.174-.006.458.458,0,0,0-.388-.322.274.274,0,0,1,.174.16c-.3-.193-.867-.248-2.272.22-1.852.617-.927,1.692-.646,1.779s.8-.467,1.263-.543.716.572.893.626.077-.094.262-.241.292.2.288.443.358.475.358.475l.212-.389a3.447,3.447,0,0,0-.048-2.057L1175.078.4",
    transform: "translate(-186.191 116.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11270",
    "data-name": "Path 11270",
    d: "M408.8,1247.41v2.1l-4.962-2.1Z",
    transform: "translate(550.803 -1081.447)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1989",
    "data-name": "Rectangle 1989",
    width: 16.411,
    height: 21.555,
    transform: "translate(985.663 148.083)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1990",
    "data-name": "Rectangle 1990",
    width: 16.411,
    height: 21.555,
    transform: "translate(980.604 148.083)",
    fill: "#37dba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    "data-name": "Path 11271",
    d: "M1472.132,798.7v3.223l-5.06-3.223Z",
    transform: "translate(-470.057 -650.618)",
    fill: "#16d696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFullTimeJobsIcon);
export default __webpack_public_path__ + "static/media/banner-full-time-jobs-icon.7132e878f32ae94a64f744f9f6d8d189.svg";
export { ForwardRef as ReactComponent };